import { ReceivedMeals } from '@/models'

let receivedMeals = new ReceivedMeals('2020-11-09', 1, 250, 2, 1, 1, 'Test', 'User');
let testLabels = { first: 'Counting', second: 'Temperature' };

export let data = {
    receivedMeals: receivedMeals,
    testLabels: testLabels
}
